<script setup lang='ts'>
const toggleSidebarCollapse = inject('sidebarCollapse', () => undefined);
</script>

<template>
	<UButton icon="i-lucide-menu" variant="ghost" size="sm" @click="toggleSidebarCollapse" />
</template>
